import React,{ createContext, useContext, useState, useEffect} from "react";
import axios from "axios";
import { baseUrl, ROUTE_BASE_URL } from "../../api/common";
import { useHistory } from 'react-router-dom';

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
    const history = useHistory();
    const [adminName, setAdminName] = useState(localStorage.getItem("loginUserName") || "");
    const [adminProfile, setAdminProfile] = useState(localStorage.getItem("loginUserImage") || "");
    const [websiteName, setWebsiteName] = useState("AMASI");
    const [websiteLogo, setWebsiteLogo] = useState("");
    const [razorpayKey, setRazorpayKey] = useState("");

    const updateUser = (name, profile) => {
        setAdminName(name);
        if (profile !== null && profile !== "" && profile !== undefined) {
         setAdminProfile(profile);
        }
    };

    const [settingsDetails, setMyProfileDetails] = useState({});

    const fetchSettingsDetails = async () => {
      try {
        const response = await axios.get(`${baseUrl}/api/settings`,{
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        });
  
        if (response.data.status) {
          const details = response.data.data[0];
          setWebsiteName(details.website_name);
          setWebsiteLogo(`${baseUrl}/${details.logo}`);
          // setWebsiteLogo(`${details.logo}`);
          setMyProfileDetails(details);
          setRazorpayKey(details.razor_key_id);
        } else {
          console.error("Error: Failed to fetch user data");
        }
      } catch (error) {
        console.error("Error fetching users data:", error);
      }
    };

    const checkPermission = async (moduleName, action) => {
      try {
        const response = await axios.post(
          `${baseUrl}/api/checkuser`,
          { moduleName, action },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: localStorage.getItem("access_token"),
            },
            // Ensure we get the response body even for 401
            validateStatus: (status) => status < 500,
          }
        );
    
        console.log("checkPermission:", response.data);
    
        if (response.status === 200 && response.data.status) {
          // Permission granted
          return true;
        } else {
          // Permission denied (401 or explicit false)
          console.error("Permission denied:", response.data.message);
          history.push(`${ROUTE_BASE_URL}/access-denied`);
          return false;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        return false;
      }
    };
    

      useEffect(() => {
        fetchSettingsDetails();
      }, []);

    return (
        <UserContext.Provider value={{razorpayKey, websiteName, websiteLogo, adminName, adminProfile, updateUser, fetchSettingsDetails, checkPermission }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);
